<template>
  <!-- div id="app" -->
    <!-- Contenuto principale -->
    <div class="container-fluid main-content">
      <router-view></router-view>
    </div>
  <!--/div-->
</template>

<script>
export default {
  name: "App",
};
</script>

